import Vue from 'vue'
import Vuex from 'vuex'
import login from './modules/login'
import permission from './modules/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    login: login,
    permission: permission
  },
  state: {
  },
  mutations: {
  },
  actions: {
  }
})
